export default "__VITE_ASSET__CyOwjQ8D__"